// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BarsChartSkeleton {
  display: flex;
  flex-direction: row;
  column-gap: 16px;
}
.BarsChartSkeleton .BarsChartSkeleton-chart {
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/bars-chart-skeleton/bars-chart-skeleton.styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AACF;AACE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AACJ","sourcesContent":[".BarsChartSkeleton {\n  display: flex;\n  flex-direction: row;\n  column-gap: 16px;\n\n  .BarsChartSkeleton-chart {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    row-gap: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
